import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useApp } from '../context/AppContext';

export default function EditProfile() {
  const { dispatch, currentUser } = useApp();
  const [name, setName] = useState(currentUser.name);
  const [bio, setBio] = useState(currentUser.bio);
  const [avatar, setAvatar] = useState(currentUser.avatar);
  const [saved, setSaved] = useState(false);
  const fileRef = useRef();

  const handleAvatarUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setAvatar(ev.target.result);
    reader.readAsDataURL(file);
  };

  const handleSave = () => {
    dispatch({ type: 'UPDATE_PROFILE', payload: { name: name.trim(), bio: bio.trim(), avatar } });
    setSaved(true);
    setTimeout(() => {
      dispatch({ type: 'SET_VIEW', payload: { view: 'profile', userId: currentUser.id } });
    }, 800);
  };

  return (
    <motion.div
      className="edit-profile"
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ type: 'spring', stiffness: 200 }}
    >
      <div className="edit-avatar-section">
        <motion.button
          className="edit-avatar-btn"
          onClick={() => fileRef.current.click()}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <div className="edit-avatar-preview">
            {avatar ? (
              <img src={avatar} alt="" />
            ) : (
              <span>{name[0] || '?'}</span>
            )}
            <div className="edit-avatar-overlay">📷</div>
          </div>
        </motion.button>
        <input ref={fileRef} type="file" accept="image/*" hidden onChange={handleAvatarUpload} />
        <p className="edit-hint">点击更换头像</p>
      </div>

      <div className="edit-form">
        <div className="form-group">
          <label>昵称</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={20}
            placeholder="输入昵称"
          />
        </div>
        <div className="form-group">
          <label>个性签名</label>
          <textarea
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            maxLength={100}
            placeholder="介绍一下自己吧"
            rows={3}
          />
        </div>

        <motion.button
          className={`btn-save ${saved ? 'saved' : ''}`}
          onClick={handleSave}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          disabled={!name.trim()}
        >
          {saved ? '✓ 保存成功' : '保存'}
        </motion.button>
      </div>
    </motion.div>
  );
}
